export default [
  {
    title: 'Inicio',
    route: 'inicio',
    icon: 'HomeIcon',
  },
]
